import { sortByDate } from "../functions/sortByDate";
import useSourceFlowCollection from "./useSourceFlowCollection";
import data from "../.sourceflow/who_we_recruit.json";

export const useWhoWeRecruit = ({ limit = null } = {}) => {
  const collection = useSourceFlowCollection(data);

  if (limit) {
    return collection.slice(0, limit);
  }

  return collection;
};

export default useWhoWeRecruit;
